import { fetchPricesIfNeeded } from '~/DatasourceComputedPrice';
import { handleError } from '~/ErrorHandler';
import { ThunkAction } from '~/Store';

export function fetchPrices(): ThunkAction<Promise<void>, any> {
	return async (dispatch) => {
		try {
			await dispatch(fetchPricesIfNeeded());
		} catch (error) {
			dispatch(handleError(error));
		}
	};
}
